<style>
  .firefly {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 1vw;
    height: 1vw;
    margin: -0.2vw 0 0 9.8vw;
    animation: ease 200s alternate infinite;
    pointer-events: none;
  }


  .dot, .firefly{
  width:6px;
  height:6px;
  position:absolute;
  background-color:#ff00cc;
  box-shadow:0px 0px 10px 2px #ff00cc;
  border-radius: 20px;
  z-index:2;
}

  .firefly::before, .firefly::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    transform-origin: -10vw; }
  .firefly::before {
    background: rgba(236, 72, 153);
    opacity: 0.4;
    animation: drift ease alternate infinite; }
  .firefly::after {
    background: white;
    opacity: 0;
    box-shadow: 0 0 0vw 0vw #da9cfb;
    animation: drift ease alternate infinite, flash ease infinite; }

  .firefly:nth-child(1) {
    animation-name: move1; }
    .firefly:nth-child(1)::before {
      animation-duration: 12s; }
    .firefly:nth-child(1)::after {
      animation-duration: 12s, 10238ms;
      animation-delay: 0ms, 2470ms; }

  @keyframes move1 {
    0% {
      transform: translateX(-5vw) translateY(-21vh) scale(1); }
    4% {
      transform: translateX(-45vw) translateY(40vh) scale(0.28); }
    8% {
      transform: translateX(7vw) translateY(12vh) scale(0.96); }
    12% {
      transform: translateX(-49vw) translateY(18vh) scale(0.75); }
    16% {
      transform: translateX(-1vw) translateY(-19vh) scale(0.69); }
    20% {
      transform: translateX(0vw) translateY(9vh) scale(0.7); }
    24% {
      transform: translateX(46vw) translateY(31vh) scale(0.96); }
    28% {
      transform: translateX(-46vw) translateY(20vh) scale(0.64); }
    32% {
      transform: translateX(4vw) translateY(39vh) scale(0.91); }
    36% {
      transform: translateX(-15vw) translateY(-44vh) scale(0.32); }
    40% {
      transform: translateX(30vw) translateY(-26vh) scale(0.54); }
    44% {
      transform: translateX(-17vw) translateY(-11vh) scale(0.86); }
    48% {
      transform: translateX(-26vw) translateY(-6vh) scale(0.69); }
    52% {
      transform: translateX(-21vw) translateY(23vh) scale(0.97); }
    56% {
      transform: translateX(29vw) translateY(3vh) scale(0.39); }
    60% {
      transform: translateX(32vw) translateY(38vh) scale(0.52); }
    64% {
      transform: translateX(-15vw) translateY(28vh) scale(0.62); }
    68% {
      transform: translateX(17vw) translateY(49vh) scale(0.94); }
    72% {
      transform: translateX(31vw) translateY(-34vh) scale(0.29); }
    76% {
      transform: translateX(50vw) translateY(25vh) scale(0.88); }
    80% {
      transform: translateX(-13vw) translateY(2vh) scale(0.89); }
    84% {
      transform: translateX(-31vw) translateY(16vh) scale(0.49); }
    88% {
      transform: translateX(11vw) translateY(-28vh) scale(0.59); }
    92% {
      transform: translateX(-10vw) translateY(19vh) scale(0.83); }
    96% {
      transform: translateX(-3vw) translateY(13vh) scale(0.67); }
    100% {
      transform: translateX(-44vw) translateY(10vh) scale(0.35); } }

  .firefly:nth-child(2) {
    animation-name: move2; }
    .firefly:nth-child(2)::before {
      animation-duration: 10s; }
    .firefly:nth-child(2)::after {
      animation-duration: 10s, 9193ms;
      animation-delay: 0ms, 7954ms; }

  @keyframes move2 {
    0% {
      transform: translateX(-18vw) translateY(33vh) scale(0.75); }
    4.16667% {
      transform: translateX(23vw) translateY(-21vh) scale(0.56); }
    8.33333% {
      transform: translateX(40vw) translateY(5vh) scale(0.26); }
    12.5% {
      transform: translateX(-31vw) translateY(-23vh) scale(0.98); }
    16.66667% {
      transform: translateX(24vw) translateY(-17vh) scale(0.94); }
    20.83333% {
      transform: translateX(-3vw) translateY(7vh) scale(0.31); }
    25% {
      transform: translateX(-12vw) translateY(35vh) scale(0.3); }
    29.16667% {
      transform: translateX(37vw) translateY(38vh) scale(0.98); }
    33.33333% {
      transform: translateX(-29vw) translateY(21vh) scale(0.76); }
    37.5% {
      transform: translateX(-34vw) translateY(7vh) scale(0.93); }
    41.66667% {
      transform: translateX(23vw) translateY(-7vh) scale(0.69); }
    45.83333% {
      transform: translateX(15vw) translateY(-3vh) scale(0.42); }
    50% {
      transform: translateX(-10vw) translateY(-36vh) scale(1); }
    54.16667% {
      transform: translateX(-3vw) translateY(43vh) scale(0.53); }
    58.33333% {
      transform: translateX(-2vw) translateY(11vh) scale(0.7); }
    62.5% {
      transform: translateX(43vw) translateY(-21vh) scale(0.3); }
    66.66667% {
      transform: translateX(14vw) translateY(25vh) scale(0.73); }
    70.83333% {
      transform: translateX(41vw) translateY(40vh) scale(0.58); }
    75% {
      transform: translateX(-31vw) translateY(-45vh) scale(0.35); }
    79.16667% {
      transform: translateX(14vw) translateY(-27vh) scale(0.48); }
    83.33333% {
      transform: translateX(-26vw) translateY(-48vh) scale(0.29); }
    87.5% {
      transform: translateX(3vw) translateY(-6vh) scale(0.58); }
    91.66667% {
      transform: translateX(34vw) translateY(23vh) scale(0.88); }
    95.83333% {
      transform: translateX(0vw) translateY(23vh) scale(0.37); }
    100% {
      transform: translateX(-15vw) translateY(-24vh) scale(0.48); } }

  .firefly:nth-child(3) {
    animation-name: move3; }
    .firefly:nth-child(3)::before {
      animation-duration: 10s; }
    .firefly:nth-child(3)::after {
      animation-duration: 10s, 5871ms;
      animation-delay: 0ms, 7135ms; }

  @keyframes move3 {
    0% {
      transform: translateX(-15vw) translateY(-30vh) scale(0.8); }
    5% {
      transform: translateX(-26vw) translateY(19vh) scale(0.28); }
    10% {
      transform: translateX(37vw) translateY(9vh) scale(0.91); }
    15% {
      transform: translateX(-6vw) translateY(-16vh) scale(0.37); }
    20% {
      transform: translateX(-46vw) translateY(8vh) scale(0.81); }
    25% {
      transform: translateX(41vw) translateY(-32vh) scale(0.32); }
    30% {
      transform: translateX(-38vw) translateY(-9vh) scale(0.7); }
    35% {
      transform: translateX(-5vw) translateY(-27vh) scale(0.81); }
    40% {
      transform: translateX(-35vw) translateY(-12vh) scale(0.49); }
    45% {
      transform: translateX(44vw) translateY(-7vh) scale(0.8); }
    50% {
      transform: translateX(-49vw) translateY(25vh) scale(0.76); }
    55% {
      transform: translateX(-30vw) translateY(-38vh) scale(0.55); }
    60% {
      transform: translateX(-32vw) translateY(-47vh) scale(0.95); }
    65% {
      transform: translateX(3vw) translateY(-42vh) scale(0.28); }
    70% {
      transform: translateX(-17vw) translateY(-39vh) scale(0.76); }
    75% {
      transform: translateX(-8vw) translateY(41vh) scale(0.82); }
    80% {
      transform: translateX(-43vw) translateY(3vh) scale(0.38); }
    85% {
      transform: translateX(-34vw) translateY(35vh) scale(0.69); }
    90% {
      transform: translateX(-31vw) translateY(-4vh) scale(0.44); }
    95% {
      transform: translateX(-27vw) translateY(29vh) scale(0.85); }
    100% {
      transform: translateX(-26vw) translateY(-48vh) scale(0.64); } }

  .firefly:nth-child(4) {
    animation-name: move4; }
    .firefly:nth-child(4)::before {
      animation-duration: 11s; }
    .firefly:nth-child(4)::after {
      animation-duration: 11s, 8974ms;
      animation-delay: 0ms, 5603ms; }

  @keyframes move4 {
    0% {
      transform: translateX(6vw) translateY(2vh) scale(0.77); }
    4.54545% {
      transform: translateX(-49vw) translateY(-15vh) scale(0.5); }
    9.09091% {
      transform: translateX(-16vw) translateY(-41vh) scale(0.6); }
    13.63636% {
      transform: translateX(-19vw) translateY(40vh) scale(0.87); }
    18.18182% {
      transform: translateX(-46vw) translateY(-16vh) scale(0.64); }
    22.72727% {
      transform: translateX(19vw) translateY(34vh) scale(0.68); }
    27.27273% {
      transform: translateX(36vw) translateY(15vh) scale(0.45); }
    31.81818% {
      transform: translateX(27vw) translateY(9vh) scale(0.8); }
    36.36364% {
      transform: translateX(-30vw) translateY(-17vh) scale(0.43); }
    40.90909% {
      transform: translateX(46vw) translateY(-22vh) scale(0.59); }
    45.45455% {
      transform: translateX(-49vw) translateY(-21vh) scale(0.75); }
    50% {
      transform: translateX(8vw) translateY(-34vh) scale(0.89); }
    54.54545% {
      transform: translateX(-37vw) translateY(30vh) scale(0.68); }
    59.09091% {
      transform: translateX(37vw) translateY(29vh) scale(0.96); }
    63.63636% {
      transform: translateX(50vw) translateY(8vh) scale(0.48); }
    68.18182% {
      transform: translateX(36vw) translateY(16vh) scale(0.99); }
    72.72727% {
      transform: translateX(0vw) translateY(23vh) scale(0.49); }
    77.27273% {
      transform: translateX(-43vw) translateY(38vh) scale(0.54); }
    81.81818% {
      transform: translateX(-9vw) translateY(19vh) scale(0.36); }
    86.36364% {
      transform: translateX(45vw) translateY(49vh) scale(0.28); }
    90.90909% {
      transform: translateX(-48vw) translateY(-40vh) scale(0.32); }
    95.45455% {
      transform: translateX(4vw) translateY(-13vh) scale(0.28); }
    100% {
      transform: translateX(7vw) translateY(-47vh) scale(0.77); } }

  .firefly:nth-child(5) {
    animation-name: move5; }
    .firefly:nth-child(5)::before {
      animation-duration: 11s; }
    .firefly:nth-child(5)::after {
      animation-duration: 11s, 6494ms;
      animation-delay: 0ms, 2297ms; }

  @keyframes move5 {
    0% {
      transform: translateX(-35vw) translateY(-6vh) scale(0.68); }
    4.54545% {
      transform: translateX(-5vw) translateY(-19vh) scale(0.99); }
    9.09091% {
      transform: translateX(50vw) translateY(-41vh) scale(0.86); }
    13.63636% {
      transform: translateX(-10vw) translateY(-29vh) scale(0.33); }
    18.18182% {
      transform: translateX(-46vw) translateY(47vh) scale(0.27); }
    22.72727% {
      transform: translateX(39vw) translateY(-7vh) scale(0.95); }
    27.27273% {
      transform: translateX(-10vw) translateY(0vh) scale(0.52); }
    31.81818% {
      transform: translateX(36vw) translateY(8vh) scale(0.37); }
    36.36364% {
      transform: translateX(12vw) translateY(49vh) scale(0.57); }
    40.90909% {
      transform: translateX(-49vw) translateY(23vh) scale(0.46); }
    45.45455% {
      transform: translateX(5vw) translateY(47vh) scale(0.89); }
    50% {
      transform: translateX(13vw) translateY(19vh) scale(0.67); }
    54.54545% {
      transform: translateX(-28vw) translateY(-41vh) scale(0.46); }
    59.09091% {
      transform: translateX(-31vw) translateY(-44vh) scale(0.98); }
    63.63636% {
      transform: translateX(-49vw) translateY(45vh) scale(0.27); }
    68.18182% {
      transform: translateX(-42vw) translateY(33vh) scale(0.85); }
    72.72727% {
      transform: translateX(-44vw) translateY(18vh) scale(0.26); }
    77.27273% {
      transform: translateX(13vw) translateY(-27vh) scale(0.63); }
    81.81818% {
      transform: translateX(29vw) translateY(12vh) scale(0.68); }
    86.36364% {
      transform: translateX(-42vw) translateY(-45vh) scale(0.5); }
    90.90909% {
      transform: translateX(37vw) translateY(-48vh) scale(0.95); }
    95.45455% {
      transform: translateX(19vw) translateY(-37vh) scale(0.92); }
    100% {
      transform: translateX(-21vw) translateY(-43vh) scale(0.37); } }

  .firefly:nth-child(6) {
    animation-name: move6; }
    .firefly:nth-child(6)::before {
      animation-duration: 15s; }
    .firefly:nth-child(6)::after {
      animation-duration: 15s, 7449ms;
      animation-delay: 0ms, 4010ms; }

  @keyframes move6 {
    0% {
      transform: translateX(-11vw) translateY(40vh) scale(0.56); }
    4.34783% {
      transform: translateX(-16vw) translateY(-44vh) scale(0.54); }
    8.69565% {
      transform: translateX(-8vw) translateY(1vh) scale(0.34); }
    13.04348% {
      transform: translateX(-35vw) translateY(20vh) scale(0.76); }
    17.3913% {
      transform: translateX(28vw) translateY(9vh) scale(0.98); }
    21.73913% {
      transform: translateX(-7vw) translateY(20vh) scale(0.66); }
    26.08696% {
      transform: translateX(37vw) translateY(-36vh) scale(0.63); }
    30.43478% {
      transform: translateX(-17vw) translateY(5vh) scale(0.38); }
    34.78261% {
      transform: translateX(-49vw) translateY(28vh) scale(0.83); }
    39.13043% {
      transform: translateX(-18vw) translateY(-48vh) scale(0.45); }
    43.47826% {
      transform: translateX(-47vw) translateY(-34vh) scale(0.66); }
    47.82609% {
      transform: translateX(5vw) translateY(-33vh) scale(0.98); }
    52.17391% {
      transform: translateX(9vw) translateY(25vh) scale(1); }
    56.52174% {
      transform: translateX(-13vw) translateY(-19vh) scale(0.88); }
    60.86957% {
      transform: translateX(25vw) translateY(8vh) scale(0.46); }
    65.21739% {
      transform: translateX(50vw) translateY(25vh) scale(0.7); }
    69.56522% {
      transform: translateX(4vw) translateY(-25vh) scale(0.65); }
    73.91304% {
      transform: translateX(25vw) translateY(29vh) scale(0.68); }
    78.26087% {
      transform: translateX(27vw) translateY(47vh) scale(0.77); }
    82.6087% {
      transform: translateX(34vw) translateY(-14vh) scale(0.92); }
    86.95652% {
      transform: translateX(5vw) translateY(39vh) scale(0.69); }
    91.30435% {
      transform: translateX(23vw) translateY(30vh) scale(0.6); }
    95.65217% {
      transform: translateX(-3vw) translateY(-23vh) scale(0.6); }
    100% {
      transform: translateX(16vw) translateY(-24vh) scale(0.89); } }

  .firefly:nth-child(7) {
    animation-name: move7; }
    .firefly:nth-child(7)::before {
      animation-duration: 13s; }
    .firefly:nth-child(7)::after {
      animation-duration: 13s, 9941ms;
      animation-delay: 0ms, 7941ms; }

  @keyframes move7 {
    0% {
      transform: translateX(-42vw) translateY(10vh) scale(0.83); }
    3.7037% {
      transform: translateX(14vw) translateY(-43vh) scale(0.31); }
    7.40741% {
      transform: translateX(-43vw) translateY(-16vh) scale(0.63); }
    11.11111% {
      transform: translateX(-40vw) translateY(-5vh) scale(0.81); }
    14.81481% {
      transform: translateX(-29vw) translateY(28vh) scale(0.87); }
    18.51852% {
      transform: translateX(43vw) translateY(47vh) scale(0.99); }
    22.22222% {
      transform: translateX(2vw) translateY(-12vh) scale(0.31); }
    25.92593% {
      transform: translateX(2vw) translateY(47vh) scale(0.28); }
    29.62963% {
      transform: translateX(26vw) translateY(-25vh) scale(0.44); }
    33.33333% {
      transform: translateX(-10vw) translateY(3vh) scale(0.53); }
    37.03704% {
      transform: translateX(20vw) translateY(-20vh) scale(0.54); }
    40.74074% {
      transform: translateX(10vw) translateY(-34vh) scale(0.99); }
    44.44444% {
      transform: translateX(26vw) translateY(31vh) scale(0.9); }
    48.14815% {
      transform: translateX(-6vw) translateY(-30vh) scale(0.32); }
    51.85185% {
      transform: translateX(8vw) translateY(6vh) scale(0.58); }
    55.55556% {
      transform: translateX(-39vw) translateY(-41vh) scale(0.31); }
    59.25926% {
      transform: translateX(-23vw) translateY(36vh) scale(0.52); }
    62.96296% {
      transform: translateX(-21vw) translateY(-33vh) scale(0.52); }
    66.66667% {
      transform: translateX(33vw) translateY(-16vh) scale(0.67); }
    70.37037% {
      transform: translateX(24vw) translateY(-4vh) scale(0.84); }
    74.07407% {
      transform: translateX(-32vw) translateY(28vh) scale(0.46); }
    77.77778% {
      transform: translateX(-15vw) translateY(-45vh) scale(0.72); }
    81.48148% {
      transform: translateX(16vw) translateY(-18vh) scale(0.68); }
    85.18519% {
      transform: translateX(-36vw) translateY(49vh) scale(0.43); }
    88.88889% {
      transform: translateX(-21vw) translateY(8vh) scale(0.4); }
    92.59259% {
      transform: translateX(-42vw) translateY(-6vh) scale(0.55); }
    96.2963% {
      transform: translateX(50vw) translateY(39vh) scale(0.45); }
    100% {
      transform: translateX(42vw) translateY(11vh) scale(0.3); } }

  .firefly:nth-child(8) {
    animation-name: move8; }
    .firefly:nth-child(8)::before {
      animation-duration: 11s; }
    .firefly:nth-child(8)::after {
      animation-duration: 11s, 7284ms;
      animation-delay: 0ms, 1071ms; }

  @keyframes move8 {
    0% {
      transform: translateX(-5vw) translateY(-42vh) scale(0.93); }
    4.7619% {
      transform: translateX(39vw) translateY(0vh) scale(0.64); }
    9.52381% {
      transform: translateX(-4vw) translateY(-3vh) scale(0.97); }
    14.28571% {
      transform: translateX(-40vw) translateY(4vh) scale(0.39); }
    19.04762% {
      transform: translateX(-16vw) translateY(40vh) scale(0.75); }
    23.80952% {
      transform: translateX(-45vw) translateY(-25vh) scale(0.7); }
    28.57143% {
      transform: translateX(-26vw) translateY(-37vh) scale(0.63); }
    33.33333% {
      transform: translateX(-22vw) translateY(-41vh) scale(0.82); }
    38.09524% {
      transform: translateX(39vw) translateY(-25vh) scale(0.91); }
    42.85714% {
      transform: translateX(41vw) translateY(13vh) scale(0.51); }
    47.61905% {
      transform: translateX(22vw) translateY(-28vh) scale(0.66); }
    52.38095% {
      transform: translateX(21vw) translateY(10vh) scale(0.31); }
    57.14286% {
      transform: translateX(-29vw) translateY(21vh) scale(0.71); }
    61.90476% {
      transform: translateX(8vw) translateY(49vh) scale(0.9); }
    66.66667% {
      transform: translateX(-33vw) translateY(14vh) scale(0.78); }
    71.42857% {
      transform: translateX(-35vw) translateY(31vh) scale(0.33); }
    76.19048% {
      transform: translateX(27vw) translateY(-5vh) scale(0.97); }
    80.95238% {
      transform: translateX(48vw) translateY(48vh) scale(0.56); }
    85.71429% {
      transform: translateX(44vw) translateY(50vh) scale(0.82); }
    90.47619% {
      transform: translateX(-9vw) translateY(46vh) scale(0.78); }
    95.2381% {
      transform: translateX(27vw) translateY(-34vh) scale(0.5); }
    100% {
      transform: translateX(-20vw) translateY(13vh) scale(0.32); } }

  .firefly:nth-child(9) {
    animation-name: move9; }
    .firefly:nth-child(9)::before {
      animation-duration: 17s; }
    .firefly:nth-child(9)::after {
      animation-duration: 17s, 10063ms;
      animation-delay: 0ms, 3161ms; }

  @keyframes move9 {
    0% {
      transform: translateX(13vw) translateY(-25vh) scale(0.96); }
    5% {
      transform: translateX(38vw) translateY(-20vh) scale(0.6); }
    10% {
      transform: translateX(-45vw) translateY(7vh) scale(0.56); }
    15% {
      transform: translateX(21vw) translateY(-31vh) scale(0.36); }
    20% {
      transform: translateX(43vw) translateY(-2vh) scale(0.31); }
    25% {
      transform: translateX(3vw) translateY(-33vh) scale(0.84); }
    30% {
      transform: translateX(19vw) translateY(-24vh) scale(0.32); }
    35% {
      transform: translateX(12vw) translateY(32vh) scale(0.51); }
    40% {
      transform: translateX(-11vw) translateY(33vh) scale(0.26); }
    45% {
      transform: translateX(9vw) translateY(44vh) scale(0.77); }
    50% {
      transform: translateX(22vw) translateY(6vh) scale(0.88); }
    55% {
      transform: translateX(8vw) translateY(2vh) scale(0.73); }
    60% {
      transform: translateX(4vw) translateY(-27vh) scale(0.31); }
    65% {
      transform: translateX(-24vw) translateY(-15vh) scale(0.71); }
    70% {
      transform: translateX(-25vw) translateY(-38vh) scale(0.89); }
    75% {
      transform: translateX(-19vw) translateY(1vh) scale(0.65); }
    80% {
      transform: translateX(-30vw) translateY(48vh) scale(0.75); }
    85% {
      transform: translateX(-17vw) translateY(28vh) scale(0.56); }
    90% {
      transform: translateX(42vw) translateY(-41vh) scale(0.33); }
    95% {
      transform: translateX(-1vw) translateY(48vh) scale(0.77); }
    100% {
      transform: translateX(18vw) translateY(7vh) scale(0.82); } }

  .firefly:nth-child(10) {
    animation-name: move10; }
    .firefly:nth-child(10)::before {
      animation-duration: 18s; }
    .firefly:nth-child(10)::after {
      animation-duration: 18s, 10279ms;
      animation-delay: 0ms, 3908ms; }

  @keyframes move10 {
    0% {
      transform: translateX(-30vw) translateY(-5vh) scale(0.76); }
    4.54545% {
      transform: translateX(-19vw) translateY(10vh) scale(0.38); }
    9.09091% {
      transform: translateX(-4vw) translateY(-34vh) scale(0.61); }
    13.63636% {
      transform: translateX(3vw) translateY(-35vh) scale(0.26); }
    18.18182% {
      transform: translateX(-15vw) translateY(-9vh) scale(0.26); }
    22.72727% {
      transform: translateX(-12vw) translateY(-21vh) scale(0.43); }
    27.27273% {
      transform: translateX(31vw) translateY(1vh) scale(0.34); }
    31.81818% {
      transform: translateX(20vw) translateY(-47vh) scale(0.33); }
    36.36364% {
      transform: translateX(49vw) translateY(2vh) scale(0.26); }
    40.90909% {
      transform: translateX(-16vw) translateY(42vh) scale(0.63); }
    45.45455% {
      transform: translateX(16vw) translateY(-49vh) scale(0.58); }
    50% {
      transform: translateX(-16vw) translateY(-5vh) scale(0.4); }
    54.54545% {
      transform: translateX(30vw) translateY(-35vh) scale(0.45); }
    59.09091% {
      transform: translateX(47vw) translateY(-3vh) scale(0.4); }
    63.63636% {
      transform: translateX(22vw) translateY(7vh) scale(0.67); }
    68.18182% {
      transform: translateX(6vw) translateY(16vh) scale(0.37); }
    72.72727% {
      transform: translateX(-47vw) translateY(31vh) scale(0.38); }
    77.27273% {
      transform: translateX(26vw) translateY(-43vh) scale(0.38); }
    81.81818% {
      transform: translateX(-49vw) translateY(-4vh) scale(0.35); }
    86.36364% {
      transform: translateX(49vw) translateY(-42vh) scale(0.75); }
    90.90909% {
      transform: translateX(-28vw) translateY(-42vh) scale(0.54); }
    95.45455% {
      transform: translateX(-10vw) translateY(-46vh) scale(0.96); }
    100% {
      transform: translateX(20vw) translateY(-31vh) scale(0.52); } }

  .firefly:nth-child(11) {
    animation-name: move11; }
    .firefly:nth-child(11)::before {
      animation-duration: 11s; }
    .firefly:nth-child(11)::after {
      animation-duration: 11s, 9140ms;
      animation-delay: 0ms, 3965ms; }

  @keyframes move11 {
    0% {
      transform: translateX(19vw) translateY(6vh) scale(0.79); }
    4.16667% {
      transform: translateX(-9vw) translateY(-5vh) scale(0.72); }
    8.33333% {
      transform: translateX(49vw) translateY(-37vh) scale(0.4); }
    12.5% {
      transform: translateX(44vw) translateY(-19vh) scale(0.64); }
    16.66667% {
      transform: translateX(-2vw) translateY(24vh) scale(0.54); }
    20.83333% {
      transform: translateX(5vw) translateY(50vh) scale(0.91); }
    25% {
      transform: translateX(-20vw) translateY(-33vh) scale(0.41); }
    29.16667% {
      transform: translateX(-24vw) translateY(15vh) scale(0.83); }
    33.33333% {
      transform: translateX(4vw) translateY(-18vh) scale(0.52); }
    37.5% {
      transform: translateX(-40vw) translateY(-32vh) scale(0.88); }
    41.66667% {
      transform: translateX(-12vw) translateY(11vh) scale(0.77); }
    45.83333% {
      transform: translateX(30vw) translateY(-21vh) scale(0.78); }
    50% {
      transform: translateX(25vw) translateY(0vh) scale(0.5); }
    54.16667% {
      transform: translateX(13vw) translateY(-29vh) scale(0.91); }
    58.33333% {
      transform: translateX(45vw) translateY(8vh) scale(0.54); }
    62.5% {
      transform: translateX(-3vw) translateY(-6vh) scale(0.78); }
    66.66667% {
      transform: translateX(-45vw) translateY(14vh) scale(0.44); }
    70.83333% {
      transform: translateX(-29vw) translateY(-34vh) scale(0.61); }
    75% {
      transform: translateX(-13vw) translateY(-49vh) scale(0.69); }
    79.16667% {
      transform: translateX(39vw) translateY(-44vh) scale(0.64); }
    83.33333% {
      transform: translateX(-25vw) translateY(-19vh) scale(0.78); }
    87.5% {
      transform: translateX(10vw) translateY(36vh) scale(0.66); }
    91.66667% {
      transform: translateX(-22vw) translateY(21vh) scale(0.92); }
    95.83333% {
      transform: translateX(33vw) translateY(-18vh) scale(0.54); }
    100% {
      transform: translateX(-39vw) translateY(-45vh) scale(0.51); } }

  .firefly:nth-child(12) {
    animation-name: move12; }
    .firefly:nth-child(12)::before {
      animation-duration: 18s; }
    .firefly:nth-child(12)::after {
      animation-duration: 18s, 10871ms;
      animation-delay: 0ms, 2194ms; }

  @keyframes move12 {
    0% {
      transform: translateX(8vw) translateY(-9vh) scale(0.51); }
    5.88235% {
      transform: translateX(-43vw) translateY(-41vh) scale(0.77); }
    11.76471% {
      transform: translateX(-3vw) translateY(-19vh) scale(0.72); }
    17.64706% {
      transform: translateX(46vw) translateY(-20vh) scale(0.82); }
    23.52941% {
      transform: translateX(-18vw) translateY(6vh) scale(0.95); }
    29.41176% {
      transform: translateX(2vw) translateY(-45vh) scale(0.97); }
    35.29412% {
      transform: translateX(-30vw) translateY(-37vh) scale(0.27); }
    41.17647% {
      transform: translateX(43vw) translateY(-30vh) scale(0.83); }
    47.05882% {
      transform: translateX(21vw) translateY(41vh) scale(0.53); }
    52.94118% {
      transform: translateX(-34vw) translateY(-31vh) scale(0.71); }
    58.82353% {
      transform: translateX(19vw) translateY(-28vh) scale(0.97); }
    64.70588% {
      transform: translateX(17vw) translateY(-22vh) scale(0.9); }
    70.58824% {
      transform: translateX(41vw) translateY(35vh) scale(0.88); }
    76.47059% {
      transform: translateX(5vw) translateY(16vh) scale(0.54); }
    82.35294% {
      transform: translateX(-46vw) translateY(18vh) scale(0.55); }
    88.23529% {
      transform: translateX(-10vw) translateY(30vh) scale(0.65); }
    94.11765% {
      transform: translateX(36vw) translateY(34vh) scale(0.97); }
    100% {
      transform: translateX(-18vw) translateY(-21vh) scale(0.89); } }

  .firefly:nth-child(13) {
    animation-name: move13; }
    .firefly:nth-child(13)::before {
      animation-duration: 15s; }
    .firefly:nth-child(13)::after {
      animation-duration: 15s, 5295ms;
      animation-delay: 0ms, 1211ms; }

  @keyframes move13 {
    0% {
      transform: translateX(-32vw) translateY(1vh) scale(0.56); }
    3.7037% {
      transform: translateX(-23vw) translateY(-14vh) scale(0.54); }
    7.40741% {
      transform: translateX(-31vw) translateY(-19vh) scale(0.69); }
    11.11111% {
      transform: translateX(-6vw) translateY(-41vh) scale(0.47); }
    14.81481% {
      transform: translateX(-23vw) translateY(11vh) scale(0.93); }
    18.51852% {
      transform: translateX(-11vw) translateY(35vh) scale(0.87); }
    22.22222% {
      transform: translateX(-32vw) translateY(-6vh) scale(0.64); }
    25.92593% {
      transform: translateX(-3vw) translateY(49vh) scale(0.29); }
    29.62963% {
      transform: translateX(-6vw) translateY(17vh) scale(0.5); }
    33.33333% {
      transform: translateX(-40vw) translateY(29vh) scale(0.6); }
    37.03704% {
      transform: translateX(-10vw) translateY(-35vh) scale(0.74); }
    40.74074% {
      transform: translateX(8vw) translateY(-40vh) scale(0.61); }
    44.44444% {
      transform: translateX(31vw) translateY(10vh) scale(0.89); }
    48.14815% {
      transform: translateX(-2vw) translateY(-19vh) scale(0.55); }
    51.85185% {
      transform: translateX(-25vw) translateY(37vh) scale(0.35); }
    55.55556% {
      transform: translateX(-35vw) translateY(20vh) scale(0.51); }
    59.25926% {
      transform: translateX(-22vw) translateY(-6vh) scale(0.91); }
    62.96296% {
      transform: translateX(35vw) translateY(-3vh) scale(0.38); }
    66.66667% {
      transform: translateX(-9vw) translateY(-37vh) scale(0.53); }
    70.37037% {
      transform: translateX(-11vw) translateY(-8vh) scale(0.96); }
    74.07407% {
      transform: translateX(4vw) translateY(-32vh) scale(0.64); }
    77.77778% {
      transform: translateX(27vw) translateY(-47vh) scale(0.46); }
    81.48148% {
      transform: translateX(-8vw) translateY(-28vh) scale(0.34); }
    85.18519% {
      transform: translateX(26vw) translateY(-41vh) scale(0.39); }
    88.88889% {
      transform: translateX(-46vw) translateY(31vh) scale(0.33); }
    92.59259% {
      transform: translateX(-38vw) translateY(27vh) scale(0.78); }
    96.2963% {
      transform: translateX(-2vw) translateY(35vh) scale(0.46); }
    100% {
      transform: translateX(25vw) translateY(-19vh) scale(0.92); } }

  .firefly:nth-child(14) {
    animation-name: move14; }
    .firefly:nth-child(14)::before {
      animation-duration: 9s; }
    .firefly:nth-child(14)::after {
      animation-duration: 9s, 10782ms;
      animation-delay: 0ms, 6084ms; }

  @keyframes move14 {
    0% {
      transform: translateX(40vw) translateY(-22vh) scale(0.26); }
    5.26316% {
      transform: translateX(33vw) translateY(-36vh) scale(0.35); }
    10.52632% {
      transform: translateX(-22vw) translateY(-18vh) scale(0.33); }
    15.78947% {
      transform: translateX(15vw) translateY(-43vh) scale(0.63); }
    21.05263% {
      transform: translateX(-35vw) translateY(42vh) scale(0.92); }
    26.31579% {
      transform: translateX(-7vw) translateY(-15vh) scale(0.63); }
    31.57895% {
      transform: translateX(-2vw) translateY(-22vh) scale(0.56); }
    36.84211% {
      transform: translateX(12vw) translateY(9vh) scale(0.29); }
    42.10526% {
      transform: translateX(-29vw) translateY(8vh) scale(0.98); }
    47.36842% {
      transform: translateX(-17vw) translateY(23vh) scale(0.87); }
    52.63158% {
      transform: translateX(-38vw) translateY(5vh) scale(0.57); }
    57.89474% {
      transform: translateX(25vw) translateY(50vh) scale(0.69); }
    63.15789% {
      transform: translateX(20vw) translateY(-29vh) scale(0.52); }
    68.42105% {
      transform: translateX(-11vw) translateY(34vh) scale(0.64); }
    73.68421% {
      transform: translateX(-39vw) translateY(-31vh) scale(0.72); }
    78.94737% {
      transform: translateX(24vw) translateY(50vh) scale(0.33); }
    84.21053% {
      transform: translateX(-19vw) translateY(49vh) scale(0.95); }
    89.47368% {
      transform: translateX(-26vw) translateY(-17vh) scale(0.73); }
    94.73684% {
      transform: translateX(35vw) translateY(5vh) scale(0.93); }
    100% {
      transform: translateX(-20vw) translateY(-17vh) scale(0.35); } }

  .firefly:nth-child(15) {
    animation-name: move15; }
    .firefly:nth-child(15)::before {
      animation-duration: 12s; }
    .firefly:nth-child(15)::after {
      animation-duration: 12s, 7615ms;
      animation-delay: 0ms, 6280ms; }

  @keyframes move15 {
    0% {
      transform: translateX(-28vw) translateY(-9vh) scale(0.62); }
    5% {
      transform: translateX(-37vw) translateY(39vh) scale(0.38); }
    10% {
      transform: translateX(27vw) translateY(11vh) scale(0.6); }
    15% {
      transform: translateX(-34vw) translateY(-42vh) scale(0.8); }
    20% {
      transform: translateX(-40vw) translateY(-15vh) scale(0.41); }
    25% {
      transform: translateX(-7vw) translateY(25vh) scale(0.88); }
    30% {
      transform: translateX(-16vw) translateY(-26vh) scale(0.55); }
    35% {
      transform: translateX(47vw) translateY(-22vh) scale(0.31); }
    40% {
      transform: translateX(-24vw) translateY(25vh) scale(0.72); }
    45% {
      transform: translateX(-22vw) translateY(14vh) scale(0.4); }
    50% {
      transform: translateX(25vw) translateY(-31vh) scale(0.53); }
    55% {
      transform: translateX(0vw) translateY(8vh) scale(1); }
    60% {
      transform: translateX(18vw) translateY(29vh) scale(0.76); }
    65% {
      transform: translateX(-31vw) translateY(14vh) scale(0.29); }
    70% {
      transform: translateX(46vw) translateY(44vh) scale(0.68); }
    75% {
      transform: translateX(16vw) translateY(33vh) scale(0.66); }
    80% {
      transform: translateX(0vw) translateY(4vh) scale(0.51); }
    85% {
      transform: translateX(-5vw) translateY(-6vh) scale(0.84); }
    90% {
      transform: translateX(-15vw) translateY(-16vh) scale(0.66); }
    95% {
      transform: translateX(-13vw) translateY(-12vh) scale(0.36); }
    100% {
      transform: translateX(13vw) translateY(2vh) scale(0.45); } }

  @keyframes drift {
    0% {
      transform: rotate(0deg); }
    100% {
      transform: rotate(360deg); } }

  @keyframes flash {
    0%, 30%, 100% {
      opacity: 0;
      box-shadow: 0 0 0vw 0vw #da9cfb; }
    5% {
      opacity: 1;
      box-shadow: 0 0 2vw 0.4vw #da9cfb; } }


  .hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 4s 8s, opacity 3s linear;
  }

  .showDelayed {
    visibility: inherit;
    opacity: 1;
    transition: visibility 4s 4s, opacity 16s linear;
  }

  .show {
    visibility: inherit;
    opacity: 1;
    transition: visibility 1s 2s, opacity 1s linear;
  }
</style>

<div class='{visibilityClass}'>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
  <div class='firefly'></div>
</div>

<script>
  import {location} from 'svelte-spa-router'
  import { connected } from './../stores.js';

  $: visibilityClass = 'hide';
  $: ($location || $connected) && triggerVisibility();

  async function triggerVisibility() {
    if($location == '/Farm') {
      visibilityClass = 'hide';
    }
    else if ($location == '/' || $location == '/Index') {
      let sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
      await sleep(2000);
      visibilityClass = 'showDelayed';
    }
    else {
      visibilityClass = 'show';
    }
  }
</script>
